<button
  type="button"
  class="btn btn-menu"
  [matMenuTriggerFor]="selectMenu"
  [matTooltip]="buttonExtendedText"
  #menuTrigger="matMenuTrigger"
  [ngSwitch]="!!period"
>
  <span class="ellipsis">
    {{ buttonExtendedText }}
  </span>
  <craft-icon class="svg-icon text-size-11 icon-arrow" name="arrows--arrow-head-down-sm"></craft-icon>
  <craft-icon
    class="svg-icon icon-remove text-size-8"
    matTooltip="Remove filter"
    matTooltipPosition="above"
    (click)="removeFilter($event)"
    name="general--close-sm"
  ></craft-icon>
</button>

<craft-icon
  class="svg-icon icon-clear text-size-9"
  matTooltip="Clear filter"
  matTooltipPosition="above"
  (click)="clearAndApply()"
  name="general--close-sm"
></craft-icon>

<mat-menu #selectMenu="matMenu">
  <ng-template matMenuContent="">
    <button
      mat-menu-item=""
      *ngFor="let p of items; trackBy: identify"
      [ngClass]="{ selected: period === p.id }"
      (click)="selectPeriod(p)"
      craftDisableFocus=""
      type="button"
    >
      {{ p.name }}
    </button>

    <button
      class="mat-mdc-menu-item"
      craftDisableFocus=""
      type="button"
      (click)="$event.stopPropagation()"
      [matMenuTriggerFor]="calendarSubMenu"
      (onMenuClose)="onCalendarClose()"
    >
      Custom
    </button>
    <hr class="hr" />
    <button
      class="mat-mdc-menu-item"
      craftDisableFocus=""
      type="button"
      (click)="clearAndApply()"
      [disabled]="!isAnySelect"
    >
      Clear
    </button>
  </ng-template>
</mat-menu>

<mat-menu #calendarSubMenu="matMenu" class="calendar-sub-menu">
  <ng-template matMenuContent="">
    <mat-calendar
      #calendar
      (click)="$event.stopPropagation()"
      (selectedChange)="selectedDate($event)"
      [selected]="dateRange"
    >
    </mat-calendar>
  </ng-template>
</mat-menu>
